import * as React from 'react';

import { ArticleHeading2 } from '@cian/ui-kit';

export interface ILetterImgProps {
  letter: string;
  className?: string;
  width?: number;
  height?: number;
}

export function LetterImg({ letter, className, width, height }: ILetterImgProps) {
  return (
    <div className={className} style={{ width, height }}>
      <ArticleHeading2 color="gray40_100">{letter}</ArticleHeading2>
    </div>
  );
}
